import { takePresenterLive } from '@shoflo/studio-redux/actions';
import { setProgram } from 'actions/program';

function toggledPresenterLive({ dispatch, getState }, { attendeeId }) {
  const { broadcastSources } = getState();

  const source = broadcastSources.sources.find(s => s.value === attendeeId);

  if (!!source) {
    dispatch(takePresenterLive(source, {}, setProgram));
  }
}

export default toggledPresenterLive;
